interface ISupplierRefundTableProps {
  data: {
    orderAmount?: {
      supplierAmount?: number;
    };
    supplierInfoData?: {
      cancellationInfo?: {
        cancellationChargeBreakUp?: {
          cancellationFees?: number;
          cancellationServiceCharge?: number;
        };
        refundAmount?: number;
      };
    };
  };
}

const formatCurrency = (amount: number = 0): string => `INR ${amount}`;

const calculateCancellationCharges = (cancellationInfo: any): number => {
  if (!cancellationInfo) return 0;
  
  const { cancellationFees = 0, cancellationServiceCharge = 0 } = 
    cancellationInfo.cancellationChargeBreakUp || {};
    
  return Math.abs(parseFloat(String(cancellationFees + cancellationServiceCharge)));
};

export const getSupplierRefundTable = (props: ISupplierRefundTableProps) => [
  {
    id: 0,
    label: 'A. Amount paid to TBO',
    value: formatCurrency(props?.data?.orderAmount?.supplierAmount),
    header: true
  },
  {
    id: 1,
    label: 'B. Cancellation charges',
    value: `- ${formatCurrency(calculateCancellationCharges(props?.data?.supplierInfoData?.cancellationInfo))}`,
    header: true
  },
  {
    id: 2,
    label: 'Cancellation Fee',
    value: formatCurrency(Math.abs(props?.data?.supplierInfoData?.cancellationInfo?.cancellationChargeBreakUp?.cancellationFees ?? 0)),
    header: false
  },
  {
    id: 3,
    label: 'Partner charges',
    value: formatCurrency(Math.abs(props?.data?.supplierInfoData?.cancellationInfo?.cancellationChargeBreakUp?.cancellationServiceCharge ?? 0)),
    header: false
  },
  {
    id: 4,
    label: 'Total refund amount',
    value: formatCurrency(props?.data?.supplierInfoData?.cancellationInfo?.refundAmount),
    header: false
  }
];
